export interface staff{
    Id: string;
    UserId: string;
    EventId: string;
    Position: string;
};

export function newStaffArray():staff[]{
    return [];
};